
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import accountService from '@/services/account.service';
  import { IGetLoginPartnerModel, ISSODataModel } from '@/models/login.model';

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'token',
        'redirectUrl'
      ])
    }
  })
  export default class Home extends Vue {
    data() {
      return {
        studio: '',
        frontUrl: '',
        websiteIcon: 'icon-font-core-games2gether',
        loginUrl: '',
        registerUrl: '',
        accessKeyUrl: '',
        loginButtonLabel: '',
        registerButtonLabel: '',
        passwordRecoveryUrl: '',
        showPasswordRecoveryButton: false,
        showRegisterButton: true,
        isLoginLoading: false,
        isRegisterLoading: false
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
      this.$data.frontUrl = this.$data.RCEnvironment.VUE_APP_FRONT_URL;
      this.$data.showPasswordRecoveryButton = !["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT);
      this.$data.websiteIcon = 'icon-font-core-games2gether';

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "CREATIVE-ASSEMBLY") {
        this.$data.loginButtonLabel = "Login/Register with CA Account";
        this.$data.registerButtonLabel ="Create a CA Account";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "STILLFRONT") {
        this.$data.loginButtonLabel = "Connect with Supremacy Account";
        this.$data.showRegisterButton = false;
      } else {
        this.$data.loginButtonLabel = "Log in";
        this.$data.registerButtonLabel = "Create an account";
      }

      if ((this.$store.getters.redirectUrl != null && this.$store.getters.redirectUrl != '') ||
        (this.$route.query.redirectUrl != null && this.$route.query.redirectUrl != '')) {
        const redirect = !this.$store.getters.redirectUrl ? this.$route.query.redirectUrl : this.$store.getters.redirectUrl;

        this.$data.loginUrl = { name: 'Login', query: { 'redirectUrl': redirect } };
        this.$data.registerUrl = { name: 'Register', query: { 'redirectUrl': redirect } };
        this.$data.accessKeyUrl = { name: 'AccessKey', query: { 'redirectUrl': redirect } }
        this.$data.passwordRecoveryUrl = { name: 'PasswordRecovery', query: { 'redirectUrl': redirect } };
      } else {
        this.$data.loginUrl = { name: 'Login' };
        this.$data.registerUrl = { name: 'Register' };
        this.$data.passwordRecoveryUrl = { name: 'PasswordRecovery' };
        this.$data.accessKeyUrl = { name: 'AccessKey' };
      }

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STILLFRONT') {
        window.addEventListener('message', this.getStillfrontData);
      }
    }

    goToLogin() {
      if (this.$data.isLoginLoading) {
        return;
      }

      this.$data.isLoginLoading = true;

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'CREATIVE-ASSEMBLY') {
        const url = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/creative-assembly/login-url";
        this.postAccountServiceToLogin(url);
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'FOCUS') {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/focus/login-url";
        this.postAccountServiceToLogin(url);
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'UBISOFT-PLAYER-COUNCIL') {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/ubisoft-player-council/login-url";
        this.postAccountServiceToLogin(url);
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STILLFRONT') {
        this.$data.isLoginLoading = false;
        this.$store.dispatch("updateRedirectUrl", this.$route.query.redirectUrl);

        window.open(
          'https://playsupremacy.com/api/auth?referrer=g2g',
          'SSOAuthPopup',
          'width=600,height=700'
        );
      } else {
        this.$data.isLoginLoading = false;
        this.$store.dispatch("updateRedirectUrl", this.$route.query.redirectUrl);
        this.$router.push(this.$data.loginUrl);
      }
    }

    private postAccountServiceToLogin(url: string) {
      accountService.post<IGetLoginPartnerModel, string>(this, url, { ClientId: this.$store.getters.clientId, RedirectUrl: this.$store.getters.redirectUrl })
        .then(response => {
          const uriSplit = response.split('?');
          const params = uriSplit.length >= 2 ? uriSplit[1] : null;

          if (params) {
            const queryString : URLSearchParams = new URLSearchParams(params);
            const loginToken = queryString.get('login_token');
            
            if (loginToken) {
              if (localStorage.getItem('login_token') == null) {
                localStorage.setItem('login_token', loginToken);
              }
            }
          }

          this.$data.isLoginLoading = false;
          this.$store.dispatch("updateIsLoading", false);
          window.location.href = response;
        });
    }

    goToRegister() {
      if (this.$data.isRegisterLoading) {
        return;
      }

      this.$data.isRegisterLoading = true;

      if (this.$data.RCEnvironment.VUE_APP_REGISTER_WITH_ACCESS_KEYS == true) {
        this.$data.isRegisterLoading = false;
        this.$router.push(this.$data.accessKeyUrl);
      } else if (['CREATIVE-ASSEMBLY', 'FOCUS', 'UBISOFT-PLAYER-COUNCIL'].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
        this.postAccountServiceToRegister();
      } else {
        this.$data.isRegisterLoading = false;
        this.$router.push(this.$data.registerUrl);
      }
    }

    private postAccountServiceToRegister(): void {
      const url = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/" + this.$data.RCEnvironment.VUE_APP_PARTNER_NAME + "/register-url";

      accountService.get<string>(this, url)
        .then(response => {
          const uriSplit = response.split('?');
          const params = uriSplit.length >= 2 ? uriSplit[1] : null;

          if (params) {
            const queryString : URLSearchParams = new URLSearchParams(params);
            const loginToken = queryString.get('login_token');
            
            if (loginToken) {
              if (localStorage.getItem('login_token') == null) {
                localStorage.setItem('login_token', loginToken);
              }
            }
          }

          this.$data.isRegisterLoading = false;
          this.$store.dispatch("updateIsLoading", false);
          window.location.href = response;
        });
    }

    private setLocalStorageState(key: string): void {
      if (localStorage.getItem(key) == null) {
        localStorage.setItem(key, this.$data.RCEnvironment.VUE_APP_ACCOUNT_URL);
      }
    }

    private getStillfrontData(event: MessageEvent): void {
      if (event.origin !== "https://playsupremacy.com") {
        return;
      }

      const ssoData: ISSODataModel = {
        AccessToken: event.data["access_token"],
        Email: event.data["email"],
        ExpiresIn: event.data["expires_in"],
        Username: event.data["username"],
        SSOId: event.data["userId"],
      } as ISSODataModel;

      this.$store.dispatch("updateSSOData", ssoData);

      this.$router.push({ name: 'LoginPartnerCallback' });
    }
  }
